import {font_s_md, font_s_sm, font_s_lg} from '../../styleGuide';
import {panel, absCenterY} from '../../globalStyles';
import colors from '../../colors';

export default {
  container: {
    width: '100%',
    background: colors.gray,
    border: colors.shade,
    position: 'relative'
  },
  empty: {
    // ...absCenter,
    // ...panel,
    background: '#fff',
    ...font_s_lg,
    padding: '2.8rem 0',
    textAlign: 'center',
    margin: 0,
  },
  newButton: {
    borderRadius: '2px'
  },
  thread: {
    borderBottom: '1px solid rgba(0,0,0,0.08)',
    padding: '18px 12px',
    background: '#f2f2f2',
    cursor: 'pointer',
    position: 'relative',
    ...font_s_md,
  },
  threadSubject: {
    ...font_s_lg,
    margin: 0,
  },
  threadDate: {
    ...font_s_sm,
    color: '#777',
  },
  threadHover: {
    background: '#fefefe',
    borderBottom: '1px solid rgba(0,0,0,0)'
  },
  notifyCircle: {
    ...absCenterY,
    right: '10px',
    width: '20px',
    height: '20px',
    background: colors.xdHighlight,
    borderRadius: '200px'
  }
}
